import { render } from "./barACtms.vue?vue&type=template&id=bcda4300"
import script from "./barACtms.vue?vue&type=script&lang=js"
export * from "./barACtms.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__